export default __webpack_public_path__ + "static/media/illustration-recruit-5-w@2x.341bbf43.webp";